<div class="login-container">
  <h2>Iniciar sesión con Wise ID</h2>
  <div class="login-buttons">
    <button class="auth-btn" type="button" (click)="loginWithQRCode()">
      <div>Código QR</div>
      <div class="auth-icon">
        <img src="assets/static/icons/qr-code.svg" alt="Código QR" />
      </div>
    </button>
  </div>

</div>
